import React from 'react';
import {Accordion as VWAccordion} from '@volkswagen-onehub/components-core';
import {AccordionProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

export function Accordion(props: AccordionProps): JSX.Element {
  return <VWAccordion {...props} />;
}
